const projectData = [
    {
        id: 1,
        image: require('@/assets/images/companies/img-1.png'),
        title: 'Firman Bachtiar 1',
        description: 'It will be as simple as Occidental',
        users: [require('@/assets/images/users/avatar-2.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        category: 'terorisme',
        created_at: '15 Oct, 2021 - 14:20:31',
        
    },
    {
        id: 2,
        image: require('@/assets/images/companies/img-2.png'),
        title: 'Firman Bachtiar 2',
        description: 'To achieve it would be necessary',
        users: [require('@/assets/images/users/avatar-3.jpg')],
        category: 'cyber',
        created_at: '22 Oct, 2021 - 14:20:31',
    },
    {
        id: 3,
        image: require('@/assets/images/companies/img-3.png'),
        title: 'Firman Bachtiar 3',
        description: 'For science, music, sport, etc',
        users: [require('@/assets/images/users/avatar-5.jpg'), require('@/assets/images/users/avatar-4.jpg')],
        category: 'politik',
        created_at: '13 Oct, 2021 - 14:20:31',
    },
    {
        id: 4,
        image: require('@/assets/images/companies/img-4.png'),
        title: 'Firman Bachtiar 4',
        description: 'If several languages coalesce',
        users: [require('@/assets/images/users/avatar-6.jpg')],
        category: 'terorisme',
        created_at: '14 Oct, 2021 - 14:20:31',
    },
    {
        id: 5,
        image: require('@/assets/images/companies/img-5.png'),
        title: 'Firman Bachtiar 5',
        description: 'Separate existence is a myth',
        users: [require('@/assets/images/users/avatar-7.jpg'), require('@/assets/images/users/avatar-8.jpg')],
        category: 'terorisme',
        created_at: '13 Oct, 2021 - 14:20:31',
    },
    {
        id: 6,
        image: require('@/assets/images/companies/img-6.png'),
        title: 'Firman Bachtiar 6',
        description: 'For science, music, sport, etc',
        users: [require('@/assets/images/users/avatar-6.jpg')],
        category: 'cyber',
        created_at: '24 Oct, 2021 - 14:20:31',
    },
    {
        id: 7,
        image: require('@/assets/images/companies/img-3.png'),
        title: 'Firman Bachtiar 7',
        description: 'It will be as simple as Occidental',
        users: [require('@/assets/images/users/avatar-3.jpg')],
        category: 'politik',
        created_at: '15 Oct, 2021 - 14:20:31',
    },
];

export { projectData };